import React from 'react'

import { useRegistrationPopup } from 'src/hooks/useRegistrationPopup'

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'src/components/shadcn/dialog'
import { Button } from 'src/components/shadcn/button'

const RegistrationPopup: () => React.JSX.Element = () => {
  const {
    showPopupState,
    translations,
    handleClose,
    handleFillAutoRoute,
    handleHome,
  } = useRegistrationPopup()

  return (
    <Dialog open={showPopupState} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{translations.postRegistrationPopup.title}</DialogTitle>
          <DialogDescription>
            {translations.postRegistrationPopup.body}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="sm:justify-start">
          <Button onClick={handleFillAutoRoute}>
            {translations.postRegistrationPopup.addAuto}
          </Button>
          <Button type="button" variant="secondary" onClick={handleHome}>
            {translations.postRegistrationPopup.btnLater}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default RegistrationPopup
